export { default } from '@klokhuis/modules/Commons/pages/HelpCenter/HelpCenter.page';
